import React from "react";
import { MaterialCell } from "./material-cell.component";
import { EmptyCell } from "./empty-cell.component";

type TMaterialProps = {
  baseSurface: string | undefined;
};

export const Material: React.FC<TMaterialProps> = ({ baseSurface }) =>
  baseSurface ? <MaterialCell title={baseSurface} /> : <EmptyCell />;